<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col class="mt-4">
            <v-img
              src="@/assets/img/em-tao-conditions-01.jpeg"
              max-width="450"
              height="964"
              cover
              class="ml-12 mx-auto">
            </v-img>
          </v-col>
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('common.conditions') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('tao.conditions.subtitle')}}
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-justify title pb-0">
                {{ $t('tao.conditions.text.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('tao.conditions.text.02')}}<br>
                {{ $t('tao.conditions.text.03')}}
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-justify title pb-0">
                {{ $t('tao.conditions.text.04')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('tao.conditions.text.05')}}<br>
                {{ $t('tao.conditions.text.06')}}
              </v-col>
            </v-row>

            <v-row>
              <v-col class="text-justify title pb-0">
                {{ $t('tao.conditions.text.07')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('tao.conditions.text.08')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                <v-alert
                  type="success"
                  icon="mdi-checkbox-marked-outline"
                  class="alert-icon"
                  border="left">
                  <v-col class="pb-2 title">{{ $t('energyManagement.service.energyMonitor.title')}}</v-col>
                  <v-col class="py-2">{{ $t('tao.conditions.text.09')}}</v-col>
                  <v-col class="text-end">
                    <v-btn
                      text
                      @click="loadPage('EnergyMonitor')">
                        {{ $t("common.intrested") }}
                      </v-btn>
                  </v-col>
                </v-alert>

              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TaoConditions',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
